import Decimal from "decimal.js";

function formatNumber(value: number | string | Decimal, maximumFractionDigits = 2, minimumFractionDigits = 0): string {
	let parsedValue: number;

	if (typeof value == "string") {
		parsedValue = parseFloat(value);
	} else if (value instanceof Decimal) {
		parsedValue = value.toNumber();
	} else {
		parsedValue = value;
	}

	return Intl.NumberFormat("nl-NL", {
		maximumFractionDigits,
		minimumFractionDigits,
	}).format(parsedValue);
}

/**
 * Formats a number using the browser's reported locale (rather than a hardcoded
 * one), grouping disabled so the output can be safely re-parsed/re-edited.
 */
function formatNumberLocale(
	value: number | string | Decimal,
	maximumFractionDigits = 6,
	minimumFractionDigits = 0,
): string {
	let parsedValue: number;

	if (typeof value == "string") {
		parsedValue = parseFloat(value);
	} else if (value instanceof Decimal) {
		parsedValue = value.toNumber();
	} else {
		parsedValue = value;
	}

	return Intl.NumberFormat(undefined, {
		maximumFractionDigits,
		minimumFractionDigits,
		useGrouping: false,
	}).format(parsedValue);
}

export { formatNumber, formatNumberLocale };
